import React, { useState } from 'react'
import { useProductBySku, ConfigurableOptions } from 'lib/modules/catalog'
import { Spinner, Button } from 'lib/ui'
import { MagentoSelectedConfigurableOption, ProductData } from 'lib/types'
import { QtyWrapper } from 'app/sofia/scenes/Cart/components/Styled'
import { Wrapper, EmptyWrapper, Message } from './styled'
import { CartItem } from 'lib/core/data/quote/cart/types'

interface CartItemData {
  [key: string]: {
    cart_item_id: number
    quantity: number
    frequency_in_cart: string | undefined
    sku: string
    new_sku?: string
  }
}

interface Props {
  sku: string
  currentVariant?: ProductData
  frequency?: number | string
  cartItemData: CartItemData
  setCartItemData: (param: CartItemData) => void
  onSubmit: () => void
  isLoading: boolean
  inputQuantity: string
  minQuantity: string
  isSubscription: boolean
  setInputQuantity: (param: string) => void
  configurableOptions?: MagentoSelectedConfigurableOption[]
  cartItem: CartItem
}

export const ItemOptions = (
  {
    sku,
    currentVariant,
    frequency,
    setCartItemData,
    onSubmit,
    cartItemData,
    isLoading,
    inputQuantity,
    minQuantity,
    isSubscription,
    setInputQuantity,
    configurableOptions,
    cartItem
  }: Props) => {
  const { product, isFetching } = useProductBySku({ sku })
  const [priceMessage, setPriceMessage] = useState('')
  const [frequencyInput, setFrequencyInput] = useState(frequency)

  if (isFetching) {
    return (
      <EmptyWrapper>
        <Spinner />
      </EmptyWrapper>
    )
  }

  if (!product) {
    return null
  }

  function handlePriceChange (price: any) {
    setPriceMessage('')
    const currentPrice = currentVariant?.price.regularPrice.amount.value
    const newPrice = price.regularPrice.amount.value
    if (currentPrice !== newPrice) {
      setPriceMessage(`This selection has a different price, the new item price will be $${newPrice}`)
    }
  }

  function handleConfigurableChange (event: any) {
    const { product } = event
    setCartItemData({
      ...cartItemData,
      [cartItem.id]: { ...cartItemData[cartItem.id], sku: product.sku }
    })
  }

  const handleFrequencyChange = (e: any) => {
    const newFrequency = e.target.value
    const frequencyInDays = parseInt(newFrequency) * 7
    setFrequencyInput(newFrequency)
    setCartItemData({
      ...cartItemData,
      [cartItem.id]: { ...cartItemData[cartItem.id], frequency_in_cart: frequencyInDays?.toString() }
    })
  }

  const handleQuantityChange = (e: any) => {
    const newQty = e.target.value
    setInputQuantity(newQty)
    setCartItemData({
      ...cartItemData,
      [cartItem.id]: { ...cartItemData[cartItem.id], quantity: newQty }
    })
  }

  const handleSubmit = () => {
    onSubmit()
  }

  return (
    <Wrapper>
      <div>
        {configurableOptions && (
          <ConfigurableOptions
            sku={sku}
            basePrice={product?.price}
            onPriceChange={handlePriceChange}
            onChange={handleConfigurableChange}
            defaultVariant={currentVariant?.sku}
          />
        )}
        {frequency && (
          <div className='product-quantity'>
            <label>Frequency</label>
            <QtyWrapper>
              <input
                type='number'
                value={frequencyInput}
                min={1}
                onFocus={e => e.target.select()}
                onChange={handleFrequencyChange}
              />
            </QtyWrapper>
          </div>
        )}
        {isSubscription && (
          <div className='product-quantity'>
            <label>Quantity</label>
            <QtyWrapper>
              <input
                type='number'
                value={inputQuantity}
                min={minQuantity}
                onFocus={e => e.target.select()}
                onChange={handleQuantityChange}
              />
            </QtyWrapper>
          </div>
        )}
      </div>
      <Message>
        {priceMessage}
      </Message>
      <Button
        onClick={handleSubmit}
        isLoading={isLoading}
        isDisabled={isLoading}
      >
        Save item updates
      </Button>
    </Wrapper>
  )
}
